export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_03.714ac2ca.jpg";